import React, { useEffect } from "react";
import LandingInfo from "../../components/LandingInfo";
import ClientsCarousel from "../../components/ClientsCarousel";
import OurProcess from "../../components/OurProcess";
import InitialSection from "../../components/InitialSection";
import FAQ from "../../components/FAQ";
import TestimonialsSection from "../../components/TestimonialsSection";
import Footer from "../../components/Footer";
import PricingPlans from "../../components/PricingPlans";
import HighlightedSection from "../../components/HighlightedSection";
import KeyBenefits from "../../components/KeyBenefits";
import ContentSection from "../../components/ContentSection";
import InteractiveMap from "../../components/InteractiveMap";
import CallToAction from "../../components/CallToAction";
import HomeOrganizationSchema from "../../components/HomeOrganizationSchema";
import {
  FaCertificate,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaUserShield,
  FaVideo,
  FaWrench,
} from "react-icons/fa";
// images
import OnsiteImage2 from "../../../src/assets/images/adobe/onsite-img-2.webp";
import { useTranslation } from "react-i18next";

const Home: React.FC = () => {
  const { t } = useTranslation();
  
  useEffect(() => {
    localStorage.setItem("previousPage", "home");
  }, []);

  const videoRemoteBenefits = t('pricingPlans.videoRemote.benefits', { returnObjects: true });
  const onSiteBenefits = t('pricingPlans.onSite.benefits', { returnObjects: true });
  const overThePhoneBenefits = t('pricingPlans.overThePhone.benefits', { returnObjects: true });
  
  const pricingPlans = [
    {
      icon: FaVideo,
      title: t('pricingPlans.videoRemote.title'),
      price: 56,
      description: t('pricingPlans.videoRemote.description'),
      benefits: Array.isArray(videoRemoteBenefits) ? videoRemoteBenefits : [],
      url: "https://orders.trustedinterpreters.com/iform-quote/KYLPv11681413693?service_type=interpretation&text=remote&landing=2&website_sale_c=www.trustedinterpreters.com",
    },
    {
      icon: FaMapMarkerAlt,
      title: t('pricingPlans.onSite.title'),
      price: 99,
      description: t('pricingPlans.onSite.description'),
      benefits: Array.isArray(onSiteBenefits) ? onSiteBenefits : [],
      url: "https://orders.trustedinterpreters.com/iform-quote/KYLPv11681413693?service_type=interpretation&text=onsite&type_i=onsite_consecutive&landing=2&website_sale_c=www.trustedinterpreters.com",
    },
    {
      icon: FaPhoneAlt,
      title: t('pricingPlans.overThePhone.title'),
      price: 1.70,
      description: t('pricingPlans.overThePhone.description'),
      benefits: Array.isArray(overThePhoneBenefits) ? overThePhoneBenefits : [],
      url: "https://orders.trustedinterpreters.com/iform-quote/KYLPv11681413693?service_type=interpretation&text=overphone&landing=2&website_sale_c=www.trustedinterpreters.com",
    },
  ];

  const benefits = [
    {
      icon: FaCertificate,
      title: "certifiedProfessionals",
      text: ""
    },
    {
      icon: FaUserShield,
      title: "privacySecurity",
      text: ""
    },
    {
      icon: FaWrench,
      title: "customizedSolutions",
      text: ""
    },
  ];

  return (
    <div className="bg-gradient-to-b from-gray-100 to-gray-200 min-h-screen">
      <div className="container mx-auto px-4 py-8">
        <InitialSection />

        <ClientsCarousel />

        <PricingPlans
          plans={pricingPlans}
        />

        <TestimonialsSection />

        <HighlightedSection title={t('keyBenefits.title')}>
          <KeyBenefits 
            benefits={benefits}
            title={t('keyBenefits.title')}
          />
        </HighlightedSection>

        <LandingInfo />

        <OurProcess />

        <div className="pt-8">
          <ContentSection
            title={t('contentSection.title')}
            content={t('contentSection.content')}
            imageUrl={OnsiteImage2}
            direction="left"
          />
        </div>

        {/* <div className="container mx-auto px-4 py-6">
          <InteractiveMap />
        </div> */}

        <div className="pt-12">
          <CallToAction
            title={t('callToAction.title')}
            description={t('callToAction.description')}
            buttonText={t('callToAction.buttonText')}
            buttonLink="/free-quote"
          />
        </div>

        <FAQ />

      </div>
      <Footer />
      <HomeOrganizationSchema />
    </div>
  );
};

export default Home;
